export default {
  getSMSForDate: '/sms/getSMSForDate',
  sendSMS: '/sms/sendSMS',
  addSMSUser: '/sms/addSmsUser',
  getSmsUsersOfAnInstitute: '/sms/getSmsUsersOfAnInstitute',
  deleteSmsUser: '/sms/deleteSmsUser'
}
